import { useCallback, useState } from "react";
import { Auth } from "shared/@auth/Auth";
import { useLogger } from "shared/@hooks/useLogger";

export function useRefund({ iboNumber, order }) {
  const { logError } = useLogger({ prefix: "useRefund" });
  const { makeAuthedRequest } = Auth.useContainer();

  const [isWaiting, setIsWaiting] = useState(false);
  const [reason, setReason] = useState("");
  const [amount, setAmount] = useState(0);

  const submit = useCallback(async () => {
    setIsWaiting(true);

    const body = JSON.stringify({
      orderId: order.id,
      reason,
      amount,
    });

    return makeAuthedRequest(`/v1/membership/transactions/${iboNumber}/bsm`, {
      method: "PUT",
      body,
    })
      .then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const json = await res.json();
          throw new Error(json.message);
        }
      })
      .catch(logError)
      .finally(() => {
        setIsWaiting(false);
      });
  }, [iboNumber, makeAuthedRequest, order, reason, amount]);

  return {
    submit,
    isWaiting,

    reason,
    setReason,

    amount,
    setAmount,
  };
}
